import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 xl:col-7" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "fluid grid" }
const _hoisted_4 = { class: "field col-12" }
const _hoisted_5 = { class: "float-right label" }
const _hoisted_6 = { autocomplete: "off" }
const _hoisted_7 = { class: "field col-12" }
const _hoisted_8 = { autocomplete: "off" }
const _hoisted_9 = { class: "field col-12" }
const _hoisted_10 = { autocomplete: "off" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Change Password", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, "# " + _toDisplayString(_ctx.loginId), 1),
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Login Email", -1)),
            _createElementVNode("form", _hoisted_6, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.userName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
                disabled: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "Login Password", -1)),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("form", _hoisted_8, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordChanged = true)),
                placeholder: "Type a new password"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Re-enter Password", -1)),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("form", _hoisted_10, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.passwordReEntered,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordReEntered) = $event)),
                modelModifiers: { trim: true },
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passworReEnteredChanged = true)),
                placeholder: "Re-enter the password"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          class: "sticky-button cancel",
          icon: "pi pi-times",
          label: _ctx.hasChanges ? 'Cancel' : 'Close',
          onClick: _ctx.cancel
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "sticky-button",
          icon: "pi pi-check",
          label: "Save",
          onClick: _ctx.changePassword,
          disabled: !_ctx.hasChanges
        }, null, 8, ["onClick", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}